import { useEffect } from "react";
import { fetchConfigDockBlockListAction } from "../../../../redux/actions/config/dockBlock";
import { useAppDispatch, useAppSelector } from "../../../../redux/hooks";
import { CustomDetailsList } from "../../../common/customDetailsList/customDetailsList";
import { Skeleton } from "../../../common/skeleton/skeleton";
import { ConfigDockBlockListColumns } from "./column/column";
import { SkeletonSizes } from "../../../../common/enum/sizes";
import { sortArray } from "../../../../utils";

export const ConfigDockBlockList = () => {
    const { list, loading, sort } = useAppSelector((state) => state.configDockBlockList);
    const dispatch = useAppDispatch();

    const renderColumns = () => {
        return ConfigDockBlockListColumns();
    };

    useEffect(() => {
        list === undefined && dispatch(fetchConfigDockBlockListAction());
    }, [list]);

    return (
        <div style={{ height: "100%" }}>
            {loading ? (
                <Skeleton rows={SkeletonSizes.DEFAULT} />
            ) : (
                <CustomDetailsList
                    data={sortArray(list, sort) ?? []}
                    renderColumns={renderColumns}
                    height={"calc(100vh - 14.5rem)"}
                />
            )}
        </div>
    );
};
